import { makeStyles, shorthands, tokens } from '@fluentui/react-components';
import { BannerMask } from '../images/BannerMask';

export const useBannerStyles = makeStyles({
  root: {
    color: 'white',
  },
  BannerCard: {
    position: 'relative',
    display: 'grid',
    gridTemplateColumns: 'auto 1fr auto',
    gridTemplateRows: 'auto auto',
    gridTemplateAreas: `
      "icon title actions"
      "icon description actions"
    `,
  },
  BannerCardNarrow: {
    gridTemplateColumns: 'min-content auto',
    gridTemplateRows: 'auto auto auto',
    gridTemplateAreas: `
      "icon title"
      "icon description"
      "icon actions"
    `,
    '& .banner-actions': {
      marginTop: 0,
    },
  },
  BannerBackground: {
    gridColumnStart: 1,
    gridColumnEnd: 'span 3',
    gridRowStart: 1,
    gridRowEnd: 'span 3',

    backgroundImage: 'linear-gradient(90deg, #005A9F, #883EE2)',
    ...shorthands.borderRadius(tokens.borderRadiusMedium),

    // put a translucent mask on top
    '::before': {
      position: 'absolute',
      width: '100%',
      height: '100%',
      content: '""',
      opacity: 0.6,
      backgroundImage: `url("${BannerMask}")`,
      backgroundSize: 'cover',
      backgroundPositionX: 'center',
      backgroundPositionY: 'center',
      ...shorthands.borderRadius(tokens.borderRadiusMedium),
    },
  },
  BannerIcon: {
    position: 'relative',
    ...shorthands.gridArea('icon'),
    marginLeft: tokens.spacingHorizontalMNudge,
    marginRight: tokens.spacingHorizontalXS,
    marginTop: tokens.spacingVerticalXL,
    marginBottom: tokens.spacingVerticalXL,
  },
});
